(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('uriActiveLinkService', uriActiveLinkService);

    function uriActiveLinkService($location) {
        return function(path) {
            return ($location.path().indexOf(path) == 0);
        };
    }
})();